import React from "react";
import { DataTable } from "./DataTable";
import { Button, message } from "antd";
import { YhBox } from "@/components/YhBox";
import { useEnquiryModel } from "../enquiryModel";
import useNavModel from "@/model/navModel";
import { globalPrompt } from "@/components/message";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/AppResourceAuthEnum";
import { useEnquiryDetailModel } from "./details/enquiryDetailModel";

export const DataBox = () => {
    const { selectedRowKeys, exportEnquiry, disableEnquiry } = useEnquiryModel(({ selectedRowKeys, searchParam }) => [selectedRowKeys, searchParam]);
    const { updateFormVal } = useEnquiryDetailModel(() => [])
    const { addNav, findNav, selectNav, switchNavState } = useNavModel(() => []);

    const onEdit = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: "请选择单条数据进行编辑，点击鼠标右键可一键选中哦！", type: "warning" });
            return;
        }
        let enquiryEditKey = "2-1-2";
        let isFindNav = findNav(enquiryEditKey);
        if (!isFindNav) {
            addNav(enquiryEditKey, { id: selectedRowKeys[0], mode: "edit" });
            updateFormVal("edit", null);
        } else {
            globalPrompt("modal", {
                title: "询价跳转详情",
                type: "warning",
                text: "您还有询价详情未保存，是否跳转",
                okText: "跳转未保存页",
                onOk: () => selectNav(isFindNav ? isFindNav.id : ""),
                cancelText: "打开新页签",
                onCancel: () => {
                    switchNavState(enquiryEditKey, { id: selectedRowKeys[0], mode: "edit" });
                    updateFormVal("edit", null);
                }
            })
        }
    }

    const action = <>
        <YhAuth resCode={ResourceAuthEnum.I_AD}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={() => addNav("2-1-1", { id: "", mode: "add" })}
            >新增</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.I_ED}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={onEdit}
            >编辑</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.I_ED_EXPORT}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={() => exportEnquiry()}
            >导出</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.I_DEL}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={() => {
                    if (!selectedRowKeys.length) {
                        message.warning("请选择你要作废的单据");
                        return;
                    }
                    globalPrompt("modal", {
                        title: "询价单作废",
                        text: ` `,
                        onOk: () => disableEnquiry(selectedRowKeys[0]),
                    })
                }}
            >作废</Button>
        </YhAuth>
    </>;

    return (
        <YhBox title="" action={action}>
            <DataTable />
        </YhBox>
    )
}